<template>
  <div class="qrcode-box">
    <div ref="qr" class="qrcode"></div>
    <div v-if="caption !== null ? caption : text" class="url">{{ caption !== null ? caption : text }}</div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'

export default {
  name: 'QrcodeBlock',
  props: {
    text: { type: String, default: '' },
    // 二维码下方文案:默认显示 text 本身;传 caption 可单独覆盖(如 2FA 只显示密钥)
    caption: { type: String, default: null },
    size: { type: Number, default: 140 }
  },
  watch: {
    text() { this.render() }
  },
  mounted() { this.render() },
  methods: {
    render() {
      const el = this.$refs.qr
      if (!el) return
      el.innerHTML = ''
      if (!this.text) return
      new QRCode(el, { text: this.text, width: this.size, height: this.size })
    }
  }
}
</script>

<style lang="less" scoped>
.qrcode-box { text-align: center; }
.qrcode { display: inline-block; }
.url { margin-top: 8px; color: #666; word-break: break-all; font-size: 12px; }
</style>
